import { ApiBase } from "../../base/_ApiBase";
import { ApiClient } from "../../base/_ApiClient";
import { BannerConfigModel } from "../../models/banners/BannerConfigModel";

export const BannerConfigApi = new class BannerApi extends ApiBase<BannerConfigModel>{
    constructor({ baseUrl }: { baseUrl: string; }) {
        super(baseUrl);
    }

}({ baseUrl: '/ads-config' });